import { FC } from 'react';
import { useSectionDetails } from '../../services/graph/hooks/category';
import { withBestEffort } from '../error/BestEffort';
import { FaFolder } from 'react-icons/fa';
import { ButtonIconLink } from './ButtonIconLink';

interface SectionLinkProps {
  driveItemId: string;
  parentSectionId?: string;
}

const SectionIconLinkContent: FC<SectionLinkProps> = ({ driveItemId, parentSectionId }) => {
  const { sectionData } = useSectionDetails(driveItemId);
  if (!sectionData) throw new Error('Could not get section data');
  if (!sectionData.name) {
    throw new Error('Section must have a name');
  }

  const toUrl = parentSectionId
    ? `/documents/myDocuments/sections/${parentSectionId}/subsections/${driveItemId}`
    : `/documents/myDocuments/sections/${driveItemId}`;

  return (
    <ButtonIconLink
      link={{
        to: toUrl,
        Icon: FaFolder,
        title: sectionData.name,
        subtitle: sectionData.description
      }}
    />
  );
};

export const SectionIconLink = withBestEffort(SectionIconLinkContent);
